import * as styles from './LoadingSpinner.css'
import type { SpinnerVariants } from './LoadingSpinner.css'

type LoadingSpinnerProps = NonNullable<SpinnerVariants> & {
  /** Optional label text below the spinner */
  label?: string
  /** Whether to show in a full-height centered container */
  fullPage?: boolean
}

/**
 * Loading spinner component for async operations.
 *
 * @example
 * // Inline spinner
 * <LoadingSpinner size="sm" />
 *
 * // Full page loading state
 * <LoadingSpinner fullPage label="Loading..." />
 */
export function LoadingSpinner({ size, label, fullPage }: LoadingSpinnerProps) {
  const spinnerElement = <div className={styles.spinner({ size })} />

  if (fullPage || label) {
    return (
      <div className={styles.container} style={fullPage ? { minHeight: '100vh' } : undefined}>
        {spinnerElement}
        {label && <p className={styles.label}>{label}</p>}
      </div>
    )
  }

  return spinnerElement
}
